import { render, staticRenderFns } from "./SalesReportProjectPage.vue?vue&type=template&id=5c1b3b87&scoped=true&"
import script from "./SalesReportProjectPage.vue?vue&type=script&lang=ts&"
export * from "./SalesReportProjectPage.vue?vue&type=script&lang=ts&"
import style0 from "./SalesReportProjectPage.vue?vue&type=style&index=0&id=5c1b3b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b3b87",
  null
  
)

export default component.exports